import { useCallback } from "react";
import { enqueueSnackbar } from "notistack";

import {
  AccountStrategy,
  useUpdateAccountStrategyMutation,
} from "features/trading/accounts";
import { NOTISTACK_FAILURE_OPTIONS } from "constants/index";

export interface ManualModeToggle {
  toggle: () => Promise<void>;
  isToggling: boolean;
}

export const useManualModeToggle = (
  accountStrategy: AccountStrategy | undefined,
): ManualModeToggle => {
  const [updateAccountStrategy, { isLoading: isToggling }] =
    useUpdateAccountStrategyMutation();

  const toggle = useCallback(async () => {
    if (!accountStrategy) return;
    try {
      await updateAccountStrategy({
        id: accountStrategy.id,
        manually_managed: !accountStrategy.manually_managed,
      }).unwrap();
    } catch {
      enqueueSnackbar(
        "Couldn't update manual mode.",
        NOTISTACK_FAILURE_OPTIONS,
      );
    }
  }, [accountStrategy, updateAccountStrategy]);

  return { toggle, isToggling };
};
